import { render } from "./ExportAbraWorkTable.vue?vue&type=template&id=71146c6b&ts=true"
import script from "./ExportAbraWorkTable.vue?vue&type=script&lang=ts"
export * from "./ExportAbraWorkTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__